export default __webpack_public_path__ + "static/media/icones_ultimo_acesso.0e5225d7.svg";